export default "__VITE_ASSET__CrFPLhsO__"